import { Icomoon } from '@constants/icomoon';
export var createIcomoonStyleSheet = function (versionValue) {
    if (typeof window === 'undefined')
        return;
    var icomoonEnv = process.env.CS_ENV === 'production' ? 'prod' : 'test';
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = "".concat(Icomoon.CDN_PATH).concat(icomoonEnv, "/style.min.css").concat(versionValue);
    style.type = 'text/css';
    document.head.appendChild(style);
};
